export const SUPPLIER_CATEGORY = {
  厂家团队: 1,
  销售团队: 2,
  共享团队: 3
};
export const EMPOLYEE_TYPE = {
  企业负责人: 1,
  部门负责人: 2,
  业务员: 3
};
export function getLevelType(storeType, data) {
  if (Number(storeType) === SUPPLIER_CATEGORY['厂家团队'] && getIsSaleTeam(data.supplierCategory)) {
    return 0;
  }
  return data.levelType;
}

export function getIsSaleTeam(type) {
  return type === SUPPLIER_CATEGORY['销售团队'] || type === SUPPLIER_CATEGORY['共享团队'];
}